import React, { useEffect, useState, useRef } from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNumberScrollAnimation } from '../useHooks/useNumberScrollAnimation';
import { useLang } from '@/i18n';

const LongTermReliability: React.FC = () => {
    const [allowTouchMove, setAllowTouchMove] = useState<boolean>(false);
    const [spaceBetween, setSpaceBetween] = useState<number>(16);
    const numRef = useNumberScrollAnimation(6439, { duration: 1000 });
    const swiperRef = useRef<any>(null);
    const { t } = useLang('Delta3AirSeries.LongTermReliability');
    const contentList: any = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1763378503764/long-item-1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1763378597203/long-item-1-m.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1763378597203/long-item-1-m.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1763378503850/long-item-2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1763378597367/long-item-2-m.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1763378597367/long-item-2-m.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 1024) {
                swiperRef.current.params.allowTouchMove = true;
                setSpaceBetween(0);
            } else {
                swiperRef.current.params.allowTouchMove = false;
                setSpaceBetween(16);
            }
            swiperRef.current.update();

            setTimeout(() => {
                const text1 = document.querySelector(`.long-item-wrap .text-box`) as HTMLElement;
                const text2 = document.querySelector(`.long-item-wrap .text-elem-box`) as HTMLElement;
                const card1 = document.querySelector(`.long-item-wrap .card-elem-box`) as HTMLElement;
                const ani = AniContainer.create({
                    triggerElement: `#D3A-LongTermReliability`,
                    triggerHook: 1,
                    offset: '0%',
                    duration: '200%',
                    asyncTimeLine: [1, 1.5, 3.2],
                    asyncFromTo: [
                        [text2, { opacity: 1 }, { opacity: 1 }, 1.3],
                        [text2, { opacity: 1 }, { opacity: 0 }, 1.5],
                        [card1, { opacity: 0 }, { opacity: 1 }, 0.6],
                    ],
                });

                return () => {
                    if (ani) AniContainer.removeScene(ani);
                };
            }, 100);
        }
    }, []);

    return (
        <section
            className={`${styles.LongTermReliability} GtmModuleData-section range8`}
            id="D3A-LongTermReliability"
            data-section-id={'D3A-LongTermReliability'}
        >
            <div className="long-item-wrap">
                <EcoImg
                    className="long-item-bg"
                    pc="https://websiteoss.ecoflow.com/upload/image/1763370982864/long-term-bg-1.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1763370982536/long-term-bg-1-m.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1763370982536/long-term-bg-1-m.jpg"
                ></EcoImg>
                <div className="animal-wrap">
                    <div className="text-box">
                        <div className="label">
                            {t.rich('title', {
                                title1: (str: string) => <div className="title">{str}</div>,
                                num1: (str: string) => <span className="num1">{str}</span>,
                            })}
                        </div>
                        <div className="desc">{t('desc')}</div>
                    </div>
                    <div className="text-elem-box">
                        <div className="label-2">
                            {t.rich('label_1', {
                                num1: (str: string) => <span ref={numRef}>{str}</span>,
                            })}
                        </div>
                        <div className="desc-2">{t('desc_2')}</div>
                    </div>
                    <div className="card-elem-box">
                        <Swiper
                            className="card-elem-swiper"
                            modules={[Navigation, Pagination]}
                            pagination
                            spaceBetween={16}
                            slidesPerView={'auto'}
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                        >
                            {contentList.map((item: any, i: number) => (
                                <SwiperSlide className="item-card-slide" key={i}>
                                    <div className="item-card">
                                        <EcoImg className="card-img" pc={item.pc} pad={item.pad} h5={item.h5}></EcoImg>
                                        <div className="card-text">
                                            <div className="card-text-title">{item.title}</div>
                                            <div className="card-text-desc">{item.desc}</div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LongTermReliability;
